import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';
import { CoreAccountingService } from '@appServices/core-accounting/core-accounting.service';

@Injectable({ providedIn: 'root' })
export class ReplacementClaimService extends CoreAccountingService {

  constructor(private httpClient: HttpClient) {
    super(httpClient, 'replacementclaim');
  }

  getReplacementClaimAttachments(attachmentId: number): Observable<Blob> {
    const url = `${this.base_url}/attachment/${attachmentId}`;
    return this.httpClient.get(url, {
      headers: this.headers,
      responseType: 'blob'
    }).pipe(
      tap(() => this.log('Fetched replacement claim attachments')),
      catchError(this.handleError<Blob>('getReplacementClaimAttachments'))
    );
  }
  
}
